import { NgModule, ModuleWithProviders } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { SgDynamicHttpInterception } from './dynamic-http-interception.service';

@NgModule({})
export class SgDynamicHttpInterceptionModule {
  constructor(dyn: SgDynamicHttpInterception) {
    dyn.autoDiscovery();
  }

  static forRoot(): ModuleWithProviders<SgDynamicHttpInterceptionModule> {
    return {
      ngModule: SgDynamicHttpInterceptionModule,
      providers: [
        SgDynamicHttpInterception,
        { provide: HTTP_INTERCEPTORS, useExisting: SgDynamicHttpInterception, multi: true },
      ],
    };
  }

  static forFeature(): ModuleWithProviders<SgDynamicHttpInterceptionModule> {
    return {
      ngModule: SgDynamicHttpInterceptionModule,
      providers: [SgDynamicHttpInterception],
    };
  }
}
